import React, {Component} from 'react'
import Icon from "../common/icon/icon.component.jsx";
import {FormattedMessage} from "react-intl";

class PaymentSource extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            type: this.props.value || '',
            className: this.props.className || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            type: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() {}



    render() {
        if (!this.state.type) {
            return ''
        }
        const icons = {
            'back-office': 'building',
            'online': 'user',
            'recurring': 'sync',
        }
        const label = {
            'back-office': <FormattedMessage
                id="payment.source.back_office"
                defaultMessage="Back-office"
            />,
            'online': <FormattedMessage
                id="payment.source.online"
                defaultMessage="Customer"
            />,
            'recurring': <FormattedMessage
                id="payment.source.recurring"
                defaultMessage="Recurring"
            />,
        }

        return <span className={this.state.className}>
            <Icon className={'mr-1'}  value={icons[this.state.type]} />
            {label[this.state.type]}
        </span>
    }

}

export default PaymentSource





// WEBPACK FOOTER //
// ./src/payment/source.component.jsx